import report_zhCN from './locales/zh-CN/report.json'
import report_en from './locales/en/report.json'
import common_zhCN from './locales/zh-CN/common.json'
import common_en from './locales/en/common.json'
import lang_zhCN from './locales/zh-CN/lang.json'
import lang_en from './locales/en/lang.json'
import main_zhCN from './locales/zh-CN/main.json'
import main_en from './locales/en/main.json'
import document_zhCN from './locales/zh-CN/document.json'
import document_en from './locales/en/document.json'
import vesselTracking_zhCN from './locales/zh-CN/vessel-tracking.json'
import vesselTracking_en from './locales/en/vessel-tracking.json'
import { defaultNS } from './constants'
import type { Resource, ResourceKey } from 'i18next'

type ResourceObject = Record<string, ResourceKey>

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
    return value !== null && typeof value === 'object' && !Array.isArray(value)
}

const compactResource = (value: unknown): ResourceKey | undefined => {
    if (!isPlainObject(value)) {
        if (value === '') return undefined
        return typeof value === 'string' ? value : String(value)
    }

    return Object.entries(value).reduce<ResourceObject>((result, [key, nextValue]) => {
        const compactedValue = compactResource(nextValue)

        if (compactedValue === undefined) {
            return result
        }

        if (isPlainObject(compactedValue) && Object.keys(compactedValue).length === 0) {
            return result
        }

        result[key] = compactedValue
        return result
    }, {})
}

const deepMerge = (...sources: unknown[]): ResourceObject => {
    const result: ResourceObject = {}

    for (const source of sources) {
        if (!isPlainObject(source)) {
            continue
        }

        for (const [key, value] of Object.entries(source)) {
            if (isPlainObject(value) && isPlainObject(result[key])) {
                result[key] = deepMerge(result[key], value)
                continue
            }

            result[key] = compactResource(value) ?? {}
        }
    }

    return result
}

export const defaultResource = {
    "zh-CN": {
        [defaultNS]: deepMerge(compactResource(main_zhCN), {
            report: report_zhCN,
            common: common_zhCN,
            lang: lang_zhCN,
        }),
        "vessel-tracking": compactResource(vesselTracking_zhCN) ?? {},
        document: compactResource(document_zhCN) ?? {},
    },
    en: {
        [defaultNS]: deepMerge(compactResource(main_en), {
            report: report_en,
            common: common_en,
            lang: lang_en,
        }),
        "vessel-tracking": compactResource(vesselTracking_en) ?? {},
        document: compactResource(document_en) ?? {},
    }
} satisfies Resource
